import {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Button from '../../../../../../components/button';
import CustomHeader from '../../../../../../components/mazraeKit/headers/homeHeader';
import SpinnerLoading from '../../../../../../components/SpinnerLoading';
import {HOME_TRAGET} from '../../../../../../services/config';
import useGetValidationReport from '../../../../../../services/hookService/getValidationReport/useGetValidationReport';
import ValidationDetailBtmSheet from './components/ValidationDetailBtmSheet';

const ValidationDetailPage = () => {
  const navigate = useNavigate();
  const {loanGuid} = useParams();
  const {data, isLoading} = useGetValidationReport(loanGuid!);
  const riskData = data?.filter(item => item.title !== 'امتیاز کل');
  const mainScore = data?.find(item => item.title === 'امتیاز کل')?.score;

  const [isOpen, setIsOpen] = useState(false);
  const [selectedRiskItem, setSelectedRiskItem] = useState<RiskItem | null>(
    null,
  );

  const handleOpenBtmSheet = (item: RiskItem) => {
    setSelectedRiskItem(item);
    setIsOpen(true);
  };

  const handleNavigateToUTM = () => {
    window.location.replace(`${HOME_TRAGET}/utm-report-select`);
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-dvh">
        <SpinnerLoading size={64} />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full bg-white h-dvh">
      {/* Header */}
      <CustomHeader
        preComponent={() => (
          <div
            className="relative flex items-center gap-2 cursor-pointer"
            onClick={() => navigate(-1)}
          >
            <i className="icon-nameArrow---Right text-[25px] text-gray-700" />
            <span className="font-medium">اعتبارسنجی</span>
          </div>
        )}
      />

      {/* Content */}
      <div className="flex flex-col w-full h-full gap-3 p-3 overflow-y-auto">
        <div className="mx-auto my-4">
          <span className="px-8 py-4 font-medium rounded-xl bg-farm-shop-50">
            امتیاز شما {mainScore}
          </span>
        </div>

        <div className="space-y-2">
          <div className="flex w-full gap-2 font-semibold text-md">
            <span className="w-3/4">شاخص های امتیازدهی</span>
            <span className="w-1/4 text-center">امتیاز</span>
          </div>

          {riskData.map(item => (
            <div key={item.title} className="flex w-full gap-2 text-md">
              <div className="flex items-center justify-between w-3/4 p-3 bg-gray-100 rounded-lg">
                <span>{item.title}</span>
                <i
                  className="text-xl cursor-pointer icon-namereport1 text-farm-shop-500"
                  onClick={() => handleOpenBtmSheet(item)}
                />
              </div>

              <div className="w-1/4 p-3 text-center bg-gray-100 rounded-lg">
                {item.score}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="w-full p-3 bg-white shadow-[0_-1px_6px_0_rgba(0,0,0,0.1)]">
        <Button
          variant="outline"
          className="w-full"
          onClick={handleNavigateToUTM}
        >
          گزارش UTM
        </Button>
      </div>

      {/* Bottom Sheet */}
      <ValidationDetailBtmSheet
        content={selectedRiskItem}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </div>
  );
};

export default ValidationDetailPage;
